import React from "react";
import { Pagination } from "antd";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PaginationContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 80px;
`;

function CustomPagination({ children, page, quantity, onChange }) {
  return (
    <Container>
      <div>{children}</div>
      <PaginationContainer>
        <Pagination
          current={page}
          defaultPageSize={1}
          onChange={onChange}
          total={quantity}
        />
      </PaginationContainer>
    </Container>
  );
}

export default CustomPagination;
